import script from "./LoaderOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderOverlay.vue?vue&type=script&setup=true&lang=js"

import "./LoaderOverlay.vue?vue&type=style&index=0&id=5681e499&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5681e499"]])

export default __exports__